<template>
  <div>
    <div class="modal__content">
      <p class="text-center mb20">Are you sure you want to remove designer file from this task?</p>

      <div class="flex flex--justify-center">
        <button class="btn btn--wide btn--gray-2 mr10" @click="$bus.$emit('modalClose')" type="button">No</button>
        <button class="btn btn--wide" @click="onConfirm">Yes</button>
      </div>
    </div>
  </div>
</template>

<script>
  export default{
    data () {
      return {
        descriptionFileKeys: []
      }
    },

    props: ['args'],

    created () {
    },

    methods: {
      onConfirm () {
        this.$bus.$emit('removeDescriptionFile', this.args.task, this.args.fileKey, this.args.tagName)
      }
    }
  }
</script>



// WEBPACK FOOTER //
// RemoveDescriptionFilesModal.vue?1894fb29